import React, { useEffect, useState } from 'react';
import { Image } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { useDispatch } from 'react-redux'; // useSelector
import { setPropertyLists, setLocationList } from '../../Store/actions/LandingPageAction';
import { postAPI, getAPI } from '../../Api';
import { logger } from '../../Utils';
import { InformationSection, ResourcesSection } from "../Landlord/Home/components";
import { HeaderLandingPage, FooterLandingPage } from "../components";
import { HeroSection, FoundFewPlaces, LovesMovingAround } from "./components";

import './style.scss';
import { Loader } from '../../App/components';
import { getAds } from '../../Utils/Ads';

const log = logger("Search");
const Search = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [propertyData, setPropertyData] = useState({})
    const [ads, setAds] = useState(null)
    // const searchLocation = useSelector(state => state.landingPageReducer.getSearchLocation) || '';
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            const ads = await getAds()
            if (ads?.length)
                setAds({ ...ads[0] })

        })()

        const timeout = setTimeout(() => {
            setIsLoading(true);
            const data = {
                // "search_term": searchLocation,
                limit: 6
            }
            postAPI('/tenant/search-property', data).then(response => {
                const res = response.data.data;
                setPropertyData(res)
                dispatch(setPropertyLists(res));
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
                log.info(error);
            });
        }, 100)

        return () => clearTimeout(timeout);
    }, [dispatch]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsLoading(true);
            getAPI('/cms/rent-panda-cities').then(response => {
                const res = response.data.data;
                const locations = res.map(list => list.city);
                dispatch(setLocationList(locations));
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
                log.info(error);
            });

        }, 100)
        return () => clearTimeout(timeout);
    }, [dispatch]);

    return (
        <div className="landing-page-tenant">
            <HeaderLandingPage />
            <HeroSection />
            <FoundFewPlaces isLoading={isLoading} listData={propertyData} />
            <div style={{ marginBottom: 40, cursor: 'pointer',display:'flex',justifyContent:'center' }}>
                {ads?
                    <a href={ads?.image_link}>
                        <Image src={ads?.image_url} alt="" />
                    </a>
                    : <Loader />}
            </div>
            <ResourcesSection />
            <LovesMovingAround isLoading={isLoading} />
            <FooterLandingPage />
        </div>
    )
}

export default withRouter(Search);
